<template>
  <div></div>
</template>

<script>
export default {
  name: 'ChatWidget',
  data() {
    return {
      widgetInitialized: false
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    isAuthenticated() {
      return this.user && this.user.id;
    }
  },
  watch: {
    isAuthenticated: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal && !oldVal && window.CuracelChatWidget) {
          // User just logged in
          this.initializeChatWidget();
        } else if (!newVal && oldVal) {
          // User just logged out
          this.destroyChatWidget();
        }
      }
    }
  },
  methods: {
    initializeChatWidget() {
      if (!window.CuracelChatWidget) {
        // If the widget script hasn't loaded yet, wait a bit and try again
        setTimeout(() => {
          if (window.CuracelChatWidget) {
            this.initializeChatWidget();
          }
        }, 1000);
        return;
      }

      const userData = {
        external_id: this.user.id ? `grow_user_${this.user.id}` : 'grow_user_anonymous',
        name: this.user.name || this.user.first_name || this.user.owner?.name || 'User',
        email: this.user.email || this.user.owner?.email || '',
        phone: this.user.phone || this.user.phone_number || this.user.owner?.phone || ''
      };

      // Only initialize if we have at least a name or email
      if (userData.name && userData.email) {
        try {
          window.CuracelChatWidget.init(userData);
          this.widgetInitialized = true;
        } catch (error) {
          console.error('Failed to initialize chat widget:', error);
        }
      }
    },
    destroyChatWidget() {
      // Reset the widget state when user logs out
      this.widgetInitialized = false;
      // You might need to call a destroy method if the widget provides one
      // For now, we'll just reset our internal state
    }
  },
  mounted() {
    // Check if the widget script is already loaded
    if (window.CuracelChatWidget && this.isAuthenticated) {
      this.initializeChatWidget();
    }
  }
}
</script> 